<template>
    <v-toolbar dense cad :color="color" fixed app :clipped-left="clipped" @click="$router.push({path:'/dashboard'})">        
        <v-toolbar-title class="ml-0 pl-3 white--text">
           <small>Hai, {{user.name}}</small>
        </v-toolbar-title>            
        <v-spacer></v-spacer>
       
        
      <v-menu offset-y origin="center center" :nudge-bottom="10" transition="scale-transition">
        <v-btn outline dark icon slot="activator">
          <v-avatar class="white" size="30">
            <img src="@/assets/logo.png" height="30" alt="Vue Material Admin Template">
          </v-avatar>                    
        </v-btn>
        <v-list class="pa-0">
          <v-list-tile class="py-2" avatar v-bind:to="{path:'/dashboard/profile/'}">
            <v-list-tile-avatar color="cyan">
              <img v-if="user.thumb" :src="user.thumb" :alt="user.name"  @error="imgUrlAlt"/>
              <span v-else class="white--text">{{user.name ? user.name.charAt(0):null}}</span>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title class="black--text"><strong>{{user.name}}</strong></v-list-tile-title>
              <small>calon siswa</small>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider></v-divider>
          <v-list-tile v-bind:to="{path:'/dashboard/profile/form'}">
            <v-list-tile-action>
              <v-icon>settings</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Ganti Password</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <!--<v-list-tile @click="$router.push({path:'/profile'})">
            <v-list-tile-action>
              <v-icon>account_circle</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Profile</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>-->
          <v-list-tile v-for="(item,index) in items" :to="!item.href ? { name: item.name } : null" :href="item.href" @click="item.click" ripple="ripple" :disabled="item.disabled" :target="item.target" rel="noopener" :key="index">
            <v-list-tile-action v-if="item.icon">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>          
      </v-menu>
      <!--<v-toolbar-side-icon dark @click.stop="handleRightDrawerToggle"></v-toolbar-side-icon>  -->
      <v-dialog v-model="dialog" scrollable max-width="300px">      
        <v-card>
          <v-card-title>Settings</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 300px;">
            <v-container grid-list-sm class="ma-0 pa-0">
              <v-layout row wrap>
                <v-flex xs3>
                  <v-btn outline :disabled="disabledforward" @click="nextPage()" icon><v-icon>arrow_forward</v-icon></v-btn>        
                </v-flex>
                <v-flex xs3>
                  <v-btn outline icon @click="handleFullScreen()">
                    <v-icon>fullscreen</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex xs3>
                  <v-btn outline icon @click.stop="fixed = !fixed">
                    <v-icon>remove</v-icon>
                  </v-btn>
                </v-flex>                
                <v-flex xs3>
                  <v-btn outline icon @click.stop="handleLeftMiniVariant">
                    <v-icon v-html="miniVariant ? 'fa-angle-right fa-lg' : 'fa-angle-left fa-lg'"></v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="blue darken-1" flat @click="dialog = false">Close</v-btn>         
          </v-card-actions>
        </v-card>
      </v-dialog>    
  </v-toolbar>
</template>
<script>
import config from '@/config'; 
import NotificationList from '../widgets/list/NotificationList';
import Notif from '@/util/models/Notif';
import Util  from '@/util';
import user  from '@/util/models/User';

const notif = new Notif();

export default {
  name: 'app-toolbar',
  components: {
    NotificationList,
  },
  data: () => ({
    disabledforward : false,
    color:config.color,
    user : user.attributes(),
    notifLength:0,
    title: 'Portal PPDB',
    miniVariant:false,
    clipped: false,
    drawer: true,
    fixed: false,
    rightDrawer: false,
    right: true,
    prevUrl : null,
    dialog:false,
    items: [          
      {
        icon: 'fullscreen_exit',
        href: '#',
        title: 'Logout',
        click: (/*e*/) => {
            window.getApp.$emit('APP_LOGOUT');
            window.getApp.$emit('showSnackbar', {
                show:true,
                text:'Logout Succesfully.',
                color:'green'
            });
        }
      }
    ],
  }),  
  computed: {
    toolbarColor () {
      return this.$vuetify.options.extra.mainNav;
    }
  },
  created () {     
     this.user.thumb = this.imageUrl('user-thumb', this.user.id);
  },  
  methods: {
    handleRightDrawerToggle () {
      window.getApp.$emit('APP_RIGHT_DRAWER_TOGGLED');      
    },
    handleLeftDrawerToggle () {
      window.getApp.$emit('APP_LEFT_DRAWER_TOGGLED');      
    },
    handleLeftMiniVariant () {
      window.getApp.$emit('APP_LEFT_MINI_VARIANT'); 
      this.miniVariant = (!this.miniVariant);
    },
    handleLeftClipped () {
      window.getApp.$emit('APP_LEFT_CLIPPED');   
      this.clipped = (!this.clipped);
    },
    handleFullScreen () {
      Util.toggleFullScreen();
    },       
    nextPage(){            
      this.$router.go(1);
      if(this.prevUrl === this.$route){
        this.disabledforward = true;
      }            
      this.prevUrl = this.$route;
    },
    prevPage(){
      this.$router.go(-1);
      this.disabledforward = false;                  
      this.prevUrl = this.$route;
    },
    imageUrl(route, id){            
      return this.$config.file + route +'?reff_id='+id+'&'+(0|Math.random()*9e6).toString(36);       
    },
    imgUrlAlt(event){
      event.target.src = require('@/assets/img/avatar.png');
    }
  }
};
</script>
